<template>
  <div class="ship-list">
    <div class="order-box">
      <img v-if="isAZ"
           class="order-icon"
           src="../../assets/png/az-blue.jpg" />
      <img v-if="!isAZ"
           class="order-icon"
           src="../../assets/png/az-gray.jpg"
           @click="formatTableData('az')" />
      <div v-if="isGroup"
           class="order-text">group</div>
      <div v-if="!isGroup"
           class="order-text"
           style="color: #e6e6e6;"
           @click="formatTableData('group')">group</div>
    </div>
    <table border=0
           cellpadding=0
           id="voyage"
           class="iceui-table">
      <thead>
        <tr class="voyage-tr voyage-th">
          <td class="voyage-td"
              v-for="(item,index) in title"
              :key="index">{{item}}</td>
          <!-- <td class="empty"> </td> -->
        </tr>
      </thead>
      <tbody id="voyageTbody">
        <tr v-for="(item, index) in tableData"
            :class="shipIndex==index?'choosed-tr':'voyage-tr'"
            :key="item.id"
            style="cursor: pointer;"
            @click="changeShip(item.mmsi,index, true)">
          <td class="table-id">{{index + 1}}</td>
          <td>{{item.name}}</td>
          <td>
            <div class="table-state">{{item.state}}</div>
          </td>
          <!-- <td>{{item.time}}</td> -->
        </tr>
      </tbody>
    </table>

  </div>
</template>
<script>
import store from "@/store/index";
import { toRaw } from "@vue/reactivity";
export default {
  props: {
    shipList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    direction: {
      type: String,
      default: () => {
        return null;
      },
    },
    isChoosed: {
      type: Boolean,
    },
    allGroupListData: {
      type: Object,
      default: () => {
        return null;
      },
    },
  },
  data() {
    return {
      title: ["序号", "名称", "状态"],
      // shipList: [],
      // allGroupListData: [], //所有获取到的groupList
      tableData: [], //最后展示的船只数据
      groupList: [], //获取到的船只数据（提取groupId,船只顺序）
      timer: null, //获取到的船只数据（主要组成部分）
      isAZ: true,
      isGroup: false,
      shipIndex: 0,
      shipMmsi: "",
    };
  },
  computed: {
    // ...mapGetters(["aisShipList"]),
  },
  mounted() {
    // this.getGroupList();
  },
  watch: {
    shipList(newValue, oldValue) {
      if (newValue) {
        // console.log(newValue,"shipList");
        this.formatTableData();
      }
      // this.autoScroll()
    },
    direction(newV) {
      if (this.tableData && newV) {
        this.changeOrder();
      }
      // console.log(newV);
    },
    tableData(newV) {
      // console.log(newV);
      let data = toRaw(newV);
      // console.log(data);
    },
    shipIndex(newV) {
      // console.log(newV);
    },
    allGroupListData: {
      handler(newV) {
        this.formatTableData("group");
      },
      deep: true,
    },
  },

  beforeDestroy() {
    // clearInterval(this.timer)
  },
  methods: {
    // 船只按接口数据排序
    formatTableData(type) {
      // this.groupList = this.allGroupListData.default_order;
      if (type === "az") {
        this.isAZ = true;
        this.isGroup = false;
        this.groupList = this.allGroupListData.name_order;
      } else if (type === "group") {
        this.isAZ = false;
        this.isGroup = true;
        this.groupList = this.allGroupListData.default_order;
      }
      // console.log(this.groupList)
      this.checkList();
    },
    // 对数据重新排序整理
    checkList() {
      this.tableData = [];
      let tabledata=[]
      let noAisShipList=[]
      if(this.shipList.length == 2) {
        //debugger
      }
      // console.log(this.groupList,"groupList<<<<<<<");
      this.groupList.forEach((group, i) => {
        let inList=false
        this.shipList.forEach((item) => {
          let state = "";
          switch (item.aisNavStatusCn) {
            case "发动机使用中":
              state = "在航";
              // tableClass = "green";
              break;
            case "在航（主机推动）":
              state = "在航";
              // tableClass = "green";
              break;
            case "系泊":
              state = item.aisNavStatusCn;
              // tableClass = "perple";
              break;
            case "锚泊":
              state = item.aisNavStatusCn;
              // tableClass = "orange";
              break;
            case "漂航":
              state = item.aisNavStatusCn;
              // tableClass = "blue";
              break;
            case "受船舶吃水限制":
              state = "吃水受限";
              // tableClass = "red";
              break;
            case "靠泊":
              state = "靠泊";
              // tableClass = "red";
              break;
            default:
              state = item.aisNavStatusCn;
              // tableClass = "gray";
              break;
          }
          // let groupId = 0;
          if (group.name === item.name) {
            inList=true
            // groupId = Number(group.group_code);
            const temp = {
              order: i + 1,
              state: state,
              mmsi: item.mmsi,
              name: item.name,
              // groupId: groupId,
            };
           tabledata.push(temp);
          }
        });
        // console.log(inList);
        /**if (this.shipList.length>0&&inList==false) {
          // let groupId = Number(group.group_code);
            let temp = {
              order: i + 1,
              state: "",
              mmsi: group.mmsi,
              name: group.name,
              // groupId: groupId,
            };
           tabledata.push(temp);
            noAisShipList.push(group.mmsi)
        }**/
      });
      this.tableData=tabledata
      store.dispatch("SET_NO_AIS_SHIP_LIST", noAisShipList);
      this.tableData.forEach((item, index) => {
        if (item.mmsi == this.shipMmsi) {
          this.shipIndex = index;
        }
      });
      let data = toRaw(this.tableData);
      if (!this.isChoosed && data.length > 1) {
        this.shipIndex = 0;
        this.shipMmsi = this.tableData[0].mmsi;
        this.changeShip(this.shipMmsi, 0);
        this.$emit("changeShow");
      }
    },
    // 手动排序(暂停使用)
    sortTableData(type) {
      if (type === "az") {
        this.isAZ = true;
        this.isGroup = false;
        this.tableData.sort((a, b) => {
          return a.name[0].charCodeAt(0) - b.name[0].charCodeAt(0);
        });
      } else if (type === "group") {
        this.isAZ = false;
        this.isGroup = true;
        this.tableData.sort((a, b) => {
          return a.groupId - b.groupId;
        });
      }
      this.tableData.forEach((item, index) => {
        if (item.mmsi == this.shipMmsi) {
          this.shipIndex = index;
        }
      });
      let data = toRaw(this.tableData);
      if (!this.isChoosed && data.length > 1) {
        this.shipIndex = 0;
        this.shipMmsi = this.tableData[0].mmsi;
        this.changeShip(this.shipMmsi, 0);
        this.$emit("changeShow");
      }
    },
    // 点击船只切换下标
    changIndex(mmsi) {
      this.tableData.forEach((item,index)=>{
        if (item.mmsi === mmsi) {
          this.shipIndex = index
        }
      })
    },
    changeShip(mmsi, index, status = false) {
      // clearInterval(this.timer)
      store.dispatch("SET_MMSI", mmsi);
      this.shipMmsi = mmsi;
      this.shipIndex = index;
      if (status) {
        this.$emit("closeList");
      }
    },
    // 点击翻页
    changeOrder() {
      if (this.direction === "up") {
        // 判断是第一个后重置为最后一个
        if (this.shipIndex === 0) {
          this.shipIndex = this.tableData.length - 1
        } else {
          this.shipIndex = this.shipIndex - 1;
        }
        store.dispatch("SET_MMSI", this.tableData[this.shipIndex].mmsi);
        this.shipMmsi = this.tableData[this.shipIndex].mmsi;
      }
      if (this.direction === "down") {
        // 判断是最后一个后重置为第一个
        if (this.shipIndex === this.tableData.length - 1) {
          this.shipIndex = 0
        } else {
          this.shipIndex = this.shipIndex + 1;
        }
        store.dispatch("SET_MMSI", this.tableData[this.shipIndex].mmsi);
        this.shipMmsi = this.tableData[this.shipIndex].mmsi;
      }
      this.$emit("finishChange");
    },
    autoScroll() {
      clearInterval(this.timer);

      if (!this.tableData || this.tableData.length === 0) {
        return;
      }
      // const parent = document.getElementById('voyageTbody')
      // const scrollHeight = parent.scrollHeight
      // let scrollTop = 0
      // console.log(parent.scrollTop, parent.scrollHeight)
      this.timer = setInterval(() => {
        const first = this.tableData[0];
        this.tableData.push(first);
        this.tableData.shift();
        // parent.scrollTop = scrollTop
        // scrollTop = scrollTop < scrollHeight ? scrollTop + 1 : 0
      }, 1000);
    },
  },
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 1920px) {
  ::v-deep.ship-list {
    position: absolute;
    width: 300px;
    max-height: 800px;
    top: 40px;
    left: 0;
    padding: 0;
    margin: 0;
    background-color: #375172;
    z-index: 9;

    .order-box {
      display: flex;
      justify-content: flex-end;
      align-items: center;

      .order-icon {
        height: 16px;
        width: 16px;
        cursor: pointer;
      }

      .order-text {
        color: #63defe;
        margin: 0 20px;
        cursor: pointer;
      }
    }

    table tbody {
      /* height: calc(100% - 20px); */
      display: block;
      overflow-y: auto;
      overflow-x: hidden;
    }
    table tbody::-webkit-scrollbar {
      width: 0px;
      background-color: rgb(49, 56, 64, 0);
    }
    table tbody::-webkit-scrollbar-thumb {
      background: rgba(43, 87, 128, 0); // 滑块颜色
    }
    table thead,
    tbody tr {
      display: table;
      table-layout: fixed;
      width: 100%;
    }
    table thead {
      margin-bottom: 2px;
    }
    table thead tr td:first-child {
      width: 30px;
    }
    table tbody tr td:first-child {
      width: 30px;
    }
    table thead tr td:nth-child(3) {
      width: 100px;
    }
    table tbody tr td:nth-child(3) {
      width: 100px;
    }

    #voyage {
      width: 100%;
      height: 100%;
      background-color: #375172;
      border-spacing: 0px !important;
      border-collapse: collapse !important;
      .empty {
        width: 6px;
      }
      tr {
        color: #ddd;
        font-size: 12px;
        font-weight: 500;
        background: rgba(0, 0, 0, 0.24);
        margin-bottom: 2px;
      }
      td {
        padding: 2px 0;
        font-size: 12px;
      }
      .voyage-th {
        /* color: #54c8db; */
        background-color: rgb(0, 0, 0, 24%);
        width: 100%;
      }
      .table-id {
        /* padding-left: 10px; */
      }

      .table-state {
        height: 16px;
        /* width: 40px; */
        font-size: 12px;
        border-radius: 3px;
        margin: auto;
      }
      .green {
        background-color: #58b664;
      }
      .perple {
        background-color: #6e76e0;
      }
      .orange {
        background-color: #d4a25c;
      }
      .blue {
        background-color: #3ca1a1;
      }
      .red {
        background-color: #c45d52;
      }
      .gray {
        background-color: #666666;
      }
    }
  }
}

@media screen and (min-width: 1921px) {
  ::v-deep.ship-list {
    position: absolute;
    width: 100%;
    max-height: 60%;
    top: 40px;
    left: 0;
    padding: 0;
    margin: 0;
    background-color: #375172;
    z-index: 9;

    .order-box {
      display: flex;
      justify-content: flex-end;
      align-items: center;

      .order-icon {
        height: 26px;
        width: 26px;
        cursor: pointer;
      }

      .order-text {
        color: #63defe;
        margin: 0 40px;
        cursor: pointer;
      }
    }

    table tbody {
      /* height: calc(100% - 50px); */
      display: block;
      overflow-y: auto;
      overflow-x: hidden;
    }
    table tbody::-webkit-scrollbar {
      width: 0px;
      background-color: rgb(49, 56, 64, 0);
    }
    table tbody::-webkit-scrollbar-thumb {
      background: rgba(43, 87, 128, 0); // 滑块颜色
    }
    table thead,
    tbody tr {
      display: table;
      table-layout: fixed;
      width: 100%;
    }

    table thead,
    tbody tr {
      display: table;
      table-layout: fixed;
      width: 100%;
    }
    table thead {
      margin-bottom: 6px;
    }

    table thead tr td:first-child {
      width: 70px;
    }
    table tbody tr td:first-child {
      width: 70px;
    }
    table thead tr td:nth-child(3) {
      width: 140px;
    }
    table tbody tr td:nth-child(3) {
      width: 140px;
    }

    #voyage {
      width: 100%;
      height: 100%;
      background-color: #375172;
      border-spacing: 0px !important;
      border-collapse: collapse !important;
      .empty {
        width: 10px;
      }
      tr {
        color: #ddd;
        font-size: 24px;
        font-weight: 500;
        background: rgba(0, 0, 0, 0.24);
        margin-bottom: 5px;
        /* height: 40px; */
      }
      td {
        font-size: 24px;
        padding: 10px 0;
      }
      .voyage-th {
        color: #54c8db;
        background-color: rgb(0, 0, 0, 24%);
        width: 100%;
      }
      .table-id {
        padding-left: 20px;
      }

      .table-state {
        height: 36px;
        /* width: 80px; */
        font-size: 24px;
        border-radius: 4px;
        margin: auto;
      }
      .green {
        background-color: #58b664;
      }
      .perple {
        background-color: #6e76e0;
      }
      .orange {
        background-color: #d4a25c;
      }
      .blue {
        background-color: #3ca1a1;
      }
      .red {
        background-color: #c45d52;
      }
      .gray {
        background-color: #666666;
      }
    }
  }
}

@media screen and (min-width: 2561px) {
  ::v-deep.ship-list {
    position: absolute;
    width: 100%;
    max-height: 60%;
    top: 50px;
    left: 0;
    padding: 0;
    margin: 0;
    background-color: #375172;
    z-index: 9;

    .order-box {
      display: flex;
      justify-content: flex-end;
      align-items: center;

      .order-icon {
        height: 50px;
        width: 50px;
        cursor: pointer;
      }

      .order-text {
        color: #63defe;
        margin: 0 60px;
        cursor: pointer;
      }
    }

    table tbody {
      /* height: calc(100% - 80px); */
      display: block;
      overflow-y: auto;
      overflow-x: hidden;
    }
    table tbody::-webkit-scrollbar {
      width: 0px;
      background-color: rgb(49, 56, 64, 0);
    }
    table tbody::-webkit-scrollbar-thumb {
      background: rgba(43, 87, 128, 0); // 滑块颜色
    }
    table thead,
    tbody tr {
      display: table;
      table-layout: fixed;
      width: 100%;
    }
    table thead,
    tbody tr {
      display: table;
      table-layout: fixed;
      width: 100%;
    }
    table thead {
      margin-bottom: 5px;
    }

    table thead tr td:first-child {
      width: 80px;
    }
    table tbody tr td:first-child {
      width: 80px;
    }
    table thead tr td:nth-child(3) {
      width: 200px;
    }
    table tbody tr td:nth-child(3) {
      width: 200px;
    }

    #voyage {
      width: 100%;
      height: 100%;
      background-color: #375172;
      border-spacing: 0px !important;
      border-collapse: collapse !important;
      // display: block;
      // overflow-y: scroll;
      .empty {
        width: 10px;
      }
      tr {
        // height: 25px;
        color: #ddd;
        font-size: 30px;
        font-weight: 500;
        background: rgba(0, 0, 0, 0.24);
        // border-radius: 8px;
        margin-bottom: 5px;
        // border-bottom: 3px solid rgba(72, 156, 255, 0.1);
      }
      td {
        font-size: 30px;
        padding: 5px 0;
      }
      .voyage-th {
        color: #54c8db;
        background-color: rgb(0, 0, 0, 24%);
        width: 100%;
      }
      .table-id {
        padding-left: 20px;
      }

      .table-state {
        height: 40px;
        /* width: 100px; */
        font-size: 30px;
        border-radius: 6px;
        margin: auto;
      }
      .green {
        background-color: #58b664;
      }
      .perple {
        background-color: #6e76e0;
      }
      .orange {
        background-color: #d4a25c;
      }
      .blue {
        background-color: #3ca1a1;
      }
      .red {
        background-color: #c45d52;
      }
      .gray {
        background-color: #666666;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.choosed-tr {
  background-color: #13345b !important;
}
.voyage-tr {
  background-color: #2a3e57 !important;
}
</style>